import * as React from 'react'
import type { SVGProps } from 'react'
const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" {...props}>
		<path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z"  fill="currentColor"/>
	</svg>
)
export default SvgPlus
